import AddIcon from '@mui/icons-material/Add';
import AutoModeIcon from '@mui/icons-material/AutoMode';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import DashboardIcon from '@mui/icons-material/Dashboard';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import RefreshIcon from '@mui/icons-material/Refresh';
import SaveIcon from '@mui/icons-material/Save';
import SearchIcon from '@mui/icons-material/Search';
import SettingsIcon from '@mui/icons-material/Settings';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';

import { LoadingButton } from '@mui/lab';
import { Button, IconButton, Tooltip } from '@mui/material';
import React from 'react';
import {
  BLACK_COLOR,
  BLUE_COLOR,
  GREEN_COLOR,
  ORANGE_COLOR,
  PURPLE_COLOR,
  RED_COLOR,
  WHITE_COLOR,
} from '../../../constants/ColorsConst';

const BotonComponent = ({
  click,
  save,
  text,
  loading,
  color,
  white,
  red,
  green,
  black,
  orange,
  purple,
  mr,
  ml,
  mt,
  mb,
  disabled,
  fullWidth = false,
  blue,
  sx,
  icon,
  variant,
  transparentBg,
  startIcon,
  setIcono,
  endIcon,
  addIcon,
  editIcon,
  saveIcon,
  refreshIcon,
  closeIcon,
  searchIcon,
  checkIcon,
  downloadIcon,
  deleteIcon,
  uploadFileIcon,
  tooltip,
  colorIcon,
  dashboardIcon,
  visibilityIcon,
  visibilityOffIcon,
  personAddIcon,
  filterIcon,
  settingsIcon,
  autoModeIcon,
  size = 'small',
}) => {
  const bgColor =
    transparentBg || variant === 'outlined'
      ? null
      : white
      ? WHITE_COLOR
      : red
      ? RED_COLOR
      : green
      ? GREEN_COLOR
      : blue
      ? BLUE_COLOR
      : orange
      ? ORANGE_COLOR
      : black
      ? BLACK_COLOR
      : purple
      ? PURPLE_COLOR
      : color || WHITE_COLOR;

  const startIconConst = addIcon ? (
    <AddIcon fontSize="inherit" sx={{ color: colorIcon }} />
  ) : closeIcon ? (
    <CloseIcon fontSize="inherit" sx={{ color: colorIcon }} />
  ) : searchIcon ? (
    <SearchIcon fontSize="inherit" sx={{ color: colorIcon }} />
  ) : checkIcon ? (
    <CheckIcon fontSize="inherit" sx={{ color: colorIcon }} />
  ) : editIcon ? (
    <EditIcon fontSize="inherit" sx={{ color: colorIcon }} />
  ) : saveIcon ? (
    <SaveIcon fontSize="inherit" sx={{ color: colorIcon }} />
  ) : refreshIcon ? (
    <RefreshIcon fontSize="inherit" sx={{ color: colorIcon }} />
  ) : downloadIcon ? (
    <FileDownloadIcon fontSize="inherit" sx={{ color: colorIcon }} />
  ) : deleteIcon ? (
    <DeleteIcon fontSize="inherit" sx={{ color: colorIcon }} />
  ) : uploadFileIcon ? (
    <UploadFileIcon fontSize="inherit" sx={{ color: colorIcon }} />
  ) : dashboardIcon ? (
    <DashboardIcon fontSize="inherit" sx={{ color: colorIcon }} />
  ) : visibilityIcon ? (
    <VisibilityIcon fontSize="inherit" sx={{ color: colorIcon }} />
  ) : visibilityOffIcon ? (
    <VisibilityOffIcon fontSize="inherit" sx={{ color: colorIcon }} />
  ) : settingsIcon ? (
    <SettingsIcon fontSize="inherit" sx={{ color: colorIcon }} />
  ) : filterIcon ? (
    <FilterAltIcon fontSize="inherit" sx={{ color: colorIcon }} />
  ) : personAddIcon ? (
    <PersonAddIcon fontSize="inherit" sx={{ color: colorIcon }} />
  ) : autoModeIcon ? (
    <AutoModeIcon fontSize="inherit" sx={{ color: colorIcon }} />
  ) : (
    setIcono ?? startIcon
  );

  const colorIconConst =
    variant === 'outlined'
      ? null
      : editIcon
      ? BLUE_COLOR
      : deleteIcon || (!red && closeIcon)
      ? RED_COLOR
      : saveIcon
      ? GREEN_COLOR
      : dashboardIcon
      ? PURPLE_COLOR
      : colorIcon || (red && closeIcon)
      ? WHITE_COLOR
      : BLACK_COLOR;

  const bLoading = (
    <LoadingButton
      onClick={click}
      variant={variant ?? 'contained'}
      loading={loading}
      sx={{
        mr: mr || 0,
        ml: ml || 0,
        mt: mt || 0,
        mb: mb || 0,
        backgroundColor: bgColor,
        color: bgColor || colorIconConst,
        '&:hover': {
          color: bgColor || colorIconConst,
        },
        ...sx,
      }}
      size={size}
    >
      {save ? 'Guardar' : text || 'Crear'}
    </LoadingButton>
  );

  const bIcon = (
    <Tooltip describeChild title={tooltip} placement="bottom">
      <IconButton
        aria-label={tooltip}
        disabled={disabled}
        onClick={click}
        sx={[
          {
            mr: mr || 0,
            ml: ml || 0,
            mt: mt || 0,
            mb: mb || 0,
            backgroundColor: bgColor,
            color: colorIconConst,
            '&:hover': {
              color: red && closeIcon ? RED_COLOR : colorIconConst,
              backgroundColor: bgColor,
            },
          },
          sx,
        ]}
        size={size}
      >
        {startIconConst}
      </IconButton>
    </Tooltip>
  );

  return icon ? (
    bIcon
  ) : loading ? (
    bLoading
  ) : (
    <Button
      fullWidth={fullWidth}
      variant={transparentBg ? null : variant ?? 'contained'}
      disabled={disabled}
      sx={[
        {
          mr: mr || 0,
          ml: ml || 0,
          mt: mt || 0,
          mb: mb || 0,
          backgroundColor: bgColor,
          color:
            variant === 'outlined'
              ? bgColor
              : white
              ? BLACK_COLOR
              : WHITE_COLOR,
          '&:hover': {
            backgroundColor: bgColor,
          },
        },
        sx,
      ]}
      size={size}
      onClick={click}
      endIcon={endIcon}
      startIcon={startIconConst}
    >
      {save ? 'GUARDAR' : text || 'Crear'}
    </Button>
  );
};

export default BotonComponent;
